import { Component, OnInit, Input } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { ProductCardModel } from './product-card.model';
@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {
  @Input('card') card: ProductCardModel;

  constructor() {
  }

  ngOnInit() {
  }

}
